module.exports = __webpack_public_path__ + "static/vision_text-738a20434245f54c70b30f22fa6167d8.svg";